import(/* webpackMode: "eager" */ "/codebuild/output/src373245377/src/apps/fanychance/src/app/error.tsx");
